import {byeSpinnyBoi, formatPrice, helloSpinnyBoi, isFps, notify, toggleFPS, isOT, toggleOT, isVendor, toggleVendor} from './common';

(function ($) {

    // init variables
    let body = $('body'),
        same_address = $('#same-address'),
        ymm_drive = $('#drive'),
        vendor = $('#vendor'),
        previous_vendor = vendor.val(),
        charge_tax = $('#charge_tax'),
        main_item_api_fields = '.item-row .partnumber, .item-row .quantity',
        ymm_required_items = '.item-row[data-item-type="wheel"] input.partnumber, .item-row[data-item-type="tire"] input.partnumber, .item-row[data-item-type="suspension"] input.partnumber',
        fitment_check_items = '#drive, .item-row[data-item-type="wheel"] input.partnumber, .item-row[data-item-type="tire"] input.partnumber',
        percent_discount_inputs = 'input.discount',
        payment_price_inputs = 'tr[data-item-type="payment"] input.price',
        upsell_price_inputs = $('.item-row.upsell input.price'),
        other_item_price_inputs = 'tr[data-item-type="other"] input.price',
        flat_discount_inputs = $('.item-row[data-item-type="discount"] input'),
        discount_reason = $('.item-row[data-item-type="discount"] select'),
        btn_add_row = '.btn--add-row',
        select2_inputs = $('.form-group-default-select2 select'),
        quote_form = $('#quoteForm'),
        cart_link = $('.cart-link-wrapper a'),
        copy_cart_link_btn = $('.copy-cart-link'),
        dropdown_inputs = '.supspension-dropdown',
        image_upload_input = '.custom-image-upload',
        image_thumbnail = '.image-upload-wrapper img',
        image_preview_modal = $('#imagePreviewModal'),
        save_button = $('#save'), 
        email = $('#email'),
        billing_email = $('#billing_email'),
        is_fps = isFps(),
        is_OT = isOT(),
        is_vendor = isVendor(),
        will_call = $('#will_call')
    ;

    const parent_url = document.referrer;
    let hubspot_deal_id = parent_url;
    const WILL_CALL_ADDRESS = {
        street: '401 County Rd U',
        city: 'Wrightstown',
        state: 'WI',
        zip: '54180',
        country: 'US'
    };

    // init plugins
    enableDeleteConfirmationPlugin();
    validateForm(quote_form);

    //auto populate addr from email
    email.change(function() {
        if (isSDW()) {
            checkForWholesaleEmail(email.val(), 'shipping', false);
        }
    });

    //auto populate addr from billing email
    billing_email.change(function() {
        if (isSDW()) {
            checkForWholesaleEmail(billing_email.val(), 'billing', false);
        }
    })

    // hide or show billing address
    same_address.change(function () {
        toggleBillingAddress($(this));
    })

    $("#vendor, #drive, #year, #make, #model, #trim, #boltpattern").on("change", function () {
        updateUpsellDropdowns();
    });

    // toggle discount reason required
    flat_discount_inputs.change(function () {
        if (flat_discount_inputs.val() > 0) {
            discount_reason.attr("required", "true");
        } else {
            discount_reason.removeAttr("required");
        }
    })

    will_call.on('change', function () {
        if (!$(this).is(':checked')) return;
        if (!isAddressEmpty('')) return;

        const fromData = {
            street:  $(this).data('street'),
            city:    $(this).data('city'),
            state:   $(this).data('state'),
            zip:     $(this).data('zip'),
            country: $(this).data('country')
        };

        const addr = (fromData.street || fromData.city || fromData.state || fromData.zip || fromData.country)
        ? fromData
        : WILL_CALL_ADDRESS;
        
        applyAddress('', addr);

        setSwitchery(same_address, false);
    });
      
    if (will_call.is(':checked') && isAddressEmpty('')) {
        const fromData = {
          street:  will_call.data('street'),
          city:    will_call.data('city'),
          state:   will_call.data('state'),
          zip:     will_call.data('zip'),
          country: will_call.data('country')
        };
        const addr = (fromData.street || fromData.city || fromData.state || fromData.zip || fromData.country)
        ? fromData
        : WILL_CALL_ADDRESS;
    
        applyAddress('', addr);

        setSwitchery(same_address, false);
    }
      

    // toggle discount amount required
    discount_reason.change(function () {
        if (discount_reason.val()) {
            flat_discount_inputs.attr("required", "true");
        } else {
            flat_discount_inputs.removeAttr("required");
        }
    })

    // handle suspension dropdown changes
    body.on('change', dropdown_inputs, function () {
        updateSuspensionOptionData($(this));
    });

    // handle upsell options on vendor change
    vendor.change(function () {
        // toggle discount reason options
        updateDiscountReasonDropdowns();
        // toggle percent discount fields
        toggleDiscountFields(vendor.val());
        // toggle tax for wholesale

        document.querySelectorAll(ymm_required_items).forEach((item) => {
            if (item.value != "") {
                $(item).trigger('change');
            }
        });

        if (vendor.val() === 'SD Wheel Wholesale') {
            checkForWholesaleEmail(email.val(), 'shipping', false);
            checkForWholesaleEmail(billing_email.val(), 'billing', false);
        } else {
            setChargeTax(1);
        }

        is_fps = isFps();
        is_OT = isOT();
        is_vendor = isVendor();

        // toggle ymm required fields for fps
        if (is_fps || previous_vendor === 'Function Powersports') {
            toggleFPS(is_fps);

            // update boltpattern options
            $.ajax({
                type: "post",
                url: api_endpoints['boltpattern_options'],
                data: {
                    isFps: is_fps
                },
                success: function (result) {
                    // placeholder
                    $('#boltpattern').html("<option selected='selected' value=''>" + 'Select Boltpattern' + "</option>");
                    $('.boltpattern-wrapper').find(`select`).html("<option selected='selected' value=''>" + 'Select Boltpattern' + "</option>");

                    // populate boltpatterns
                    $.each(result, function (index, element) {
                        $('#boltpattern').append("<option value='" + index + "'>" + element + "</option>");
                        $('.boltpattern-wrapper').find(`select`).append("<option value='" + index + "'>" + element + "</option>");
                    });
                }
            });
        }

        if (is_OT || previous_vendor === 'Only Tires') {
            toggleOT(is_OT);
        }

        if (is_vendor || previous_vendor === 'Vision Wheel' || previous_vendor === 'Hardrock Offroad') {
            toggleVendor(is_vendor);
        }
        // save previous vendor for future updates
        previous_vendor = vendor.val();
    });

    // handle change on partnumbers or quantity fields.
    body.on('change', main_item_api_fields, function () {
        updateLineItem($(this));
    });

    // handle % discounts
    body.on('change', percent_discount_inputs, function () {
        updateDiscountedPrice($(this));
        updateTotals();
    });

    // update totals when changing price of other items
    body.on('change', other_item_price_inputs, function () {
        updateTotals();
    });

    // update totals when changing price of other items
    body.on('change', payment_price_inputs, function () {
        updatePaymentPrice($(this));
        updateTotals();
    });

    // check fitment when wheel/tires/ymm change
    body.on('change', fitment_check_items, function () {
        updateFitmentWarning($(this));
    });

    // handle flat discount when manually updating upsell price
    upsell_price_inputs.change(function () {
        updateTotals();
    });

    // handle flat discount with reason
    flat_discount_inputs.change(function () {
        updateTotals();
    });

    // add new line item
    body.on('click', btn_add_row, function () {
        addLineItem($(this));
    });

    // trigger change for select2 to play nice with parsley validation
    select2_inputs.change(function () {
        $(this).trigger('input');
    });

    // copy cart link to clipboard
    copy_cart_link_btn.click(function () {
        copyCartLink(copy_cart_link_btn, cart_link);
    });

    // get deal id from hubspot
    if (hubspot_deal_id.includes("hubspot")) {
        hubspot_deal_id = hubspot_deal_id.split("deal/")[1];
        hubspot_deal_id = hubspot_deal_id.replace('/', '');
        $('input[name="deal_id"]').val(hubspot_deal_id);
    }

    // upload image via AJAX
    $(image_upload_input).on('change', function () {
        uploadImage($(this));
    });

    // open large image in modal
    body.on('click', image_thumbnail, function () {
        loadImageOnModal(image_preview_modal, $(this));
    });

    save_button.click(function () {
        if (vendor.val() === 'SD Wheel Wholesale') {
            checkForWholesaleEmail(email.val(), 'shipping');
            checkForWholesaleEmail(billing_email.val(), 'billing');
        }
    });

    updateTotals();

})(jQuery);

/**
 * Validate quote form
 *
 * @param {HTMLFormElement} form
 */
function validateForm(form) {

    $(form).parsley().refresh();

    window.Parsley
        .addValidator("requiredIfDiffBilling", {  // billing address validation enabled if "Same Billing" is not checked
            validateString: function (value) {
                if (!jQuery('#same-address').is(':checked')) {
                    return !!value;
                }

                return true;
            },
            messages: {
                en: '!',
            },
            priority: 33
        });

    window.Parsley
        .addValidator("requiredIfCustomYmm", {
            validateString: function (value) {
                if (!jQuery('#custom_ymm').is(':checked')){
                    return !!value;
                }

                return true;
            },
            messages: {
                en: '!',
            },
        });

    window.Parsley
        .addValidator("requiredIfApplicable", {  // for fields (Cab/Package) that only apply to some vehicles - skip validation while hidden
            validateString: function (value, requirement, instance) {
                if (!instance.$element.is(':visible')) {
                    return true;
                }

                if (!jQuery('#custom_ymm').is(':checked')) {
                    return !!value;
                }

                return true;
            },
            messages: {
                en: '!',
            },
        });

    window.Parsley
        .addValidator("requiredRemoveEmailRequirement", {
            validateString: function (value) {
                if (!jQuery('#remove_email_requirement').is(':checked')) {
                    return !!value;
                }

                return true;
            },
            messages: {
                en: '!',
            },
        });

    window.Parsley
        .addValidator("requiredReasonIfDiscount", {  // discount reason validation enabled if discount is entered
            validateString: function (value) {
                    return !((jQuery('.item-row[data-item-type="discount"] input').val() > 0
                        && !jQuery('.item-row[data-item-type="discount"] select').val()));
                },
                messages: {
                    en: '!',
                },
                priority: 33
            });
            
    if (form.length) {
        let parsley = form.parsley({
            classHandler: function (el) {
                if (el.$element.closest('.form-group-default').length) {
                    return el.$element.closest('.form-group-default');
                }

                return el.$element.parent();
            },
        });

        parsley.on('form:error', function () {
            notify('Validation errors found.', 'error');
        });

        window.Parsley.addMessage('en', 'required', '!');
    }
}

/**
 * Show or hide the billing address section
 * @param that clicked checkbox
 */
function toggleBillingAddress(that) {
    if (that.is(':checked')) {
        $('.billing-inputs').hide();
    } else {
        $('.billing-inputs').show();
    }
}

/**
 * Updates discount reason options
 */
function updateDiscountReasonDropdowns() {
    let vendor = $('#vendor').val();
    $.ajax({
        type: "post",
        url: api_endpoints['discount_options'],
        data: {
            vendor: vendor,
        }
    }).done(function (result) {

        let select = $('tr[data-item-type="discount"] select.discount-reason');

        if (result.hasOwnProperty('options')
            && result.options) {

            select.html('');
            select.append($('<option>', {
                value: '',
                text: 'Select Reason'
            }));
            $.each(result.options, function (value, text) {
                select.append($('<option>', {
                    value: value,
                    text: text
                }));
            });
            select.trigger('change');
        }

    }).fail(function (error) {
        let message = 'Error loading Discount options.';
        if (error.hasOwnProperty('messages')) {
            message = error.messages;
        }

        notify(message, 'error');
    });
}

/**
 * List of Canadian provinces and US states and their abbreviations
 * Used for setting state and country selects based on DB input (abbreviation or full name)
 */
const CA_PROVINCES = {
    AB: 'Alberta',
    BC: 'British Columbia',
    MB: 'Manitoba',
    NB: 'New Brunswick',
    NL: 'Newfoundland and Labrador',
    NT: 'Northwest Territories',
    NS: 'Nova Scotia',
    NU: 'Nunavut',
    ON: 'Ontario',
    PE: 'Prince Edward Island',
    QC: 'Quebec',
    SK: 'Saskatchewan',
    YT: 'Yukon'
};
const US_STATES = {
        AL:'Alabama', AK:'Alaska', AZ:'Arizona', AR:'Arkansas',
        AA:'Armed Forces America', AE:'Armed Forces Europe', AP:'Armed Forces Pacific',
        CA:'California', CO:'Colorado', CT:'Connecticut', DE:'Delaware',
        DC:'District of Columbia', FL:'Florida', GA:'Georgia', HI:'Hawaii', ID:'Idaho',
        IL:'Illinois', IN:'Indiana', IA:'Iowa', KS:'Kansas', KY:'Kentucky',
        LA:'Louisiana', ME:'Maine', MD:'Maryland', MA:'Massachusetts', MI:'Michigan',
        MN:'Minnesota', MS:'Mississippi', MO:'Missouri', MT:'Montana',
        NE:'Nebraska', NV:'Nevada', NH:'New Hampshire', NJ:'New Jersey',
        NM:'New Mexico', NY:'New York', NC:'North Carolina', ND:'North Dakota',
        OH:'Ohio', OK:'Oklahoma', OR:'Oregon', PA:'Pennsylvania', RI:'Rhode Island',
        SC:'South Carolina', SD:'South Dakota', TN:'Tennessee', TX:'Texas',
        UT:'Utah', VT:'Vermont', VA:'Virginia', WA:'Washington',
        WV:'West Virginia', WI:'Wisconsin', WY:'Wyoming'
};
const US_NAME_TO_ABBR = Object.fromEntries(
    Object.entries(US_STATES).map(([abbr, name]) => [name.toLowerCase(), abbr])
);
const CA_NAME_TO_ABBR = Object.fromEntries(
    Object.entries(CA_PROVINCES).map(([abbr, name]) => [name.toLowerCase(), abbr])
);

/**
 * Set the state and country selects based on the provided state/province name or abbreviation
 * @param {*} $stateSelect 
 * @param {*} $countrySelect 
 * @param {*} state 
 */
function setStateAndCountry($stateSelect, $countrySelect, state) {
    if (!$stateSelect || !$stateSelect.length) return;
    const strState = String(state || '').trim();
    const upState = strState.toUpperCase(), lowState = strState.toLowerCase();

    let country, abbr, name;
    if (US_STATES[upState]) {
      country='US'; abbr=upState; name=US_STATES[upState];
    } else if (US_NAME_TO_ABBR[lowState]) {
      country='US'; abbr=US_NAME_TO_ABBR[lowState]; name=US_STATES[abbr];
    } else if (CA_PROVINCES[upState]) {
      country='CA'; abbr=upState; name=CA_PROVINCES[abbr];
    } else if (CA_NAME_TO_ABBR[lowState]) {
      country='CA'; abbr = CA_NAME_TO_ABBR[lowState]; name=CA_PROVINCES[abbr];
    } else {
      notify(`Unknown state/province "${state}".`, 'warning');
      return;
    }
  
    if ($countrySelect && $countrySelect.length) setCountrySelect($countrySelect, country);
    const $byVal = $stateSelect.find(`option[value="${abbr}"], option[value="${name}"]`);
    if ($byVal.length) { $stateSelect.val($byVal.first().val()).trigger('change'); return; }
  
    notify(`State/province option not found for "${name}" (${abbr}).`, 'warning');
}

/**
 * Set the country select based on the provided country code
 * @param {*} $countrySelect 
 * @param {*} code 
 */
function setCountrySelect($countrySelect, code) {
    if (!$countrySelect || !$countrySelect.length || !code) return;
    const val = code === 'CA' ? 'CA' : 'US';
    const $byVal = $countrySelect.find(`option[value="${val}"]`);
    if ($byVal.length) { $countrySelect.val($byVal.first().val()).trigger('change'); return; }
  
    notify(`Country option not found for "${val}".`, 'warning');
}
/**
 * Check if the provided email is a wholesale email, and if so, populate address fields and set tax charge accordingly when verifyOnly is false
 * @param {*} email 
 * @param {*} target 
 * @param {*} verifyOnly 
 */
function checkForWholesaleEmail(email, target = 'shipping', verifyOnly = true) {
    if (!email) return;

    $.ajax({
        type: "post",
        url: api_endpoints['check_wholesale_email'],
        data: {
           email: email,
        }
    }).done(function (result) {
        const is_billing = target === 'billing';
        let email_input = '';
        if (is_billing) {
            email_input = document.querySelector('input[name="billing_email"]');
        } else {
            email_input = document.querySelector('input[name="email"]');
        }
        if (result.status === 'failed') {
            notify(result.message, 'error');
            email_input.parentElement.classList.add('parsley-error');
            setChargeTax(1);
        } else {
            email_input.parentElement.classList.remove('parsley-error');
            if (result.status === 'not_live') {
                notify(result.message, 'warning');
                setChargeTax(1);
            } else {
                if (!verifyOnly) setChargeTax(0);
            }
            if (!verifyOnly || result.status === 'not_live') {
                if (is_billing) {
                    $('input[name="billing_street"]').val(result.address).trigger('input').trigger('change');
                    $('input[name="billing_city"]').val(result.city).trigger('input').trigger('change');
                    const $billing_state = $('select[name="billing_state"]');
                    const $billing_country = $('select[name="billing_country"]');
                    if (result.state) {
                        setStateAndCountry($billing_state, $billing_country, result.state);
                    } else {
                        $billing_state.val('').trigger('change');
                    }
                    $('input[name="billing_zip"]').val(result.zip).trigger('input').trigger('change');
                } else {
                    $('input[name="street"]').val(result.address).trigger('input').trigger('change');
                    $('input[name="city"]').val(result.city).trigger('input').trigger('change');
                    const $state = $('select[name="state"]');
                    const $country = $('select[name="country"]');
                    if (result.state) {
                        setStateAndCountry($state, $country, result.state);
                    } else {
                        $state.val('').trigger('change');
                    }
                    $('input[name="zip"]').val(result.zip).trigger('input').trigger('change');
                }
            }
        }
    }).fail(function (error) {
        let message = 'Error checking wholesale email.';
        if (error.hasOwnProperty('messages')) {
            message = error.messages;
        }

        notify(message, 'error');
    })
}

function applyAddress(prefix, addr) {
  const $state   = $(`select[name="${prefix}state"]`);
  const $country = $(`select[name="${prefix}country"]`);

  $(`input[name="${prefix}street"]`).val(addr.street || '').trigger('input').trigger('change');
  $(`input[name="${prefix}city"]`).val(addr.city || '').trigger('input').trigger('change');

  setStateAndCountry($state, $country, addr.state || '');
  if (addr.country) setCountrySelect($country, addr.country);

  $(`input[name="${prefix}zip"]`).val(addr.zip || '').trigger('input').trigger('change');

}

function isAddressEmpty(prefix = '') {
    const street  = $(`input[name="${prefix}street"]`).val()?.trim() || '';
    const city    = $(`input[name="${prefix}city"]`).val()?.trim() || '';
    const state   = $(`select[name="${prefix}state"]`).val()?.trim() || '';
    const zip     = $(`input[name="${prefix}zip"]`).val()?.trim() || '';
    return !street && !city && !state && !zip;
}

function setSwitchery($el, checked, triggerChange = true) {
  if (!$el || !$el.length) return;
  const el = $el.get(0);
  const $ui = $el.next('.switchery');

  if ($ui.length) {
    if (el.checked !== checked) $ui.trigger('click');
    return;
  }

  if (el.checked !== checked) el.checked = checked;
  if (triggerChange) $el.trigger('change');
}


/**
 * Update upsell dropdown options depending on wheel/ymm/vendor
 * @param wheelPart wheel part-number
 * @param wheelQuantity
 */
function updateUpsellDropdowns(wheelPart = '', wheelQuantity = '', tirePart = '') {
    let vendor = $('#vendor').val(),
        year = $('#year').val(),
        make = $('#make').val(),
        model = $('#model').val();

    if (!wheelPart || !wheelQuantity) {
        let item_row = $(`.item-row[data-item-type="wheel"]`).eq(0);
        wheelPart = item_row.find('input.partnumber').val();
        wheelQuantity = item_row.find('input.quantity').val();
    }

    if (!tirePart) {
        tirePart = $(`.item-row[data-item-type="tire"]`).eq(0).find('input.partnumber').val() || '';
    }

    // Single call to fetch every upsell type, then distribute to each dropdown.

    // Update lug upsell options
    let lugBoltpattern = $('#boltpattern').val();

    if (year && make && model && (wheelPart || lugBoltpattern)) {
        $.ajax({
            type: "post",
            url: api_endpoints['lug_info'],
            data: {
                year: year,
                make: make,
                model: model,
                drive: $('#drive').val(),
                trim: $('#trim').val(),
                wheelPart: wheelPart,
                vendor: vendor,
                boltpattern: lugBoltpattern,
            }
        }).done(function (result) {

            let select = $('tr[data-item-type="lugs"] select.partnumber');
            let row = $('tr[data-item-type="lugs"]');

            if (result.hasOwnProperty('options') && result.options
                && result.hasOwnProperty('prices') && result.prices) {

                let previousValue = select.val();

                select.html('');
                $.each(result.options, function (value, text) {
                    select.append($('<option>', {
                        value: value,
                        text: text,
                        'data-price': result.prices[value]['data-price'],
                        'data-margin': result.prices[value]['data-margin'],
                    }));
                });

                let stillAvailable = select.find('option').filter(function () {
                    return this.value === previousValue;
                }).length;

                if (previousValue && stillAvailable) {
                    select.val(previousValue);
                }

                select.trigger('change');

                if (Object.keys(result.options).length > 1) {
                    row.show();
                }
            }
        }).fail(function (error) {
            let message = 'Error loading Lug options.';
            if (error.hasOwnProperty('messages')) {
                message = error.messages;
            }

            notify(message, 'error');
        }).always(function () {
            toggleUpsell();
            byeSpinnyBoi();
        });
    } else if (! year || ! make || ! model) {
        resetLugOptions();
    }

    $.ajax({
        type: "post",
        url: api_endpoints['upsell_options'],
        data: {
            vendor: vendor,
            year: year,
            make: make,
            model: model,
            drive: $('#drive').val(),
            trim: $('#trim').val(),
            wheelPart: wheelPart,
            wheelQuantity: wheelQuantity,
            tirePart: tirePart,
        }
    }).done(function (result) {
        result = result || {};

        if (year && make && model) {
            populateUpsellSelect('sensor', result.sensor, { preserve: true, tool: true });
        }
        populateUpsellSelect('hubrings', result.hubrings, { showHide: true });
        populateUpsellSelect('spare', result.spare, { showHide: true, zeroOnEmpty: true });
        populateUpsellSelect('polish', result.polish, { showHide: true, minOptions: 2 });
        populateUpsellSelect('ceramic', result.ceramic);
        populateCapsSelect(result.caps);
        populateUpsellSelect('shipping', result.shipping);
        populateUpsellSelect('shine', result.shine);
        populateUpsellSelect('nqarp', result.nqarp, { showHide: true });

    }).fail(function (error) {
        let message = 'Error loading upsell options.';
        if (error.hasOwnProperty('messages')) {
            message = error.messages;
        }

        notify(message, 'error');
    }).always(function () {
        toggleUpsell();
        byeSpinnyBoi();
    });

}

/**
 * Populate a single upsell dropdown from its slice of the combined response.
 * @param type upsell item-type (sensor, lugs, ceramic, ...)
 * @param data { options, prices } slice for that type
 * @param opts { preserve, tool, showHide, zeroOnEmpty }
 */
function populateUpsellSelect(type, data, opts = {}) {
    let row = $('tr[data-item-type="' + type + '"]');
    let select = row.find('select.partnumber');

    let optionCount = (data && data.options) ? Object.keys(data.options).length : 0;
    let hasData = data && data.options && data.prices && optionCount >= (opts.minOptions || 1);
    if (!hasData) {
        if (opts.zeroOnEmpty) {
            select.parents('tr').find('input.price').val(0);
            select.parents('tr').find('input.original-price').val(0);
        }
        if (opts.showHide) {
            row.hide();
        }
        return;
    }

    let previousValue = opts.preserve ? select.val() : null;

    select.html('');
    $.each(data.options, function (value, text) {
        let price = data.prices[value] || {};
        let attrs = {
            value: value,
            text: text,
            'data-price': price['data-price'],
            'data-margin': price['data-margin'],
        };
        if (opts.tool) {
            attrs['data-tool'] = price['data-tool'];
        }
        select.append($('<option>', attrs));
    });

    if (previousValue && select.find('option[value="' + previousValue + '"]').length) {
        select.val(previousValue);
    }

    if (opts.showHide) {
        row.show();
    }

    select.trigger('change');
}

/**
 * Populate the wholesale stem-caps dropdown (price-suffixed labels, per-set price).
 * @param caps { options, prices } slice
 */
function populateCapsSelect(caps) {
    let select = $('tr[data-item-type="caps"] select.partnumber');

    if (!caps || !caps.options || !caps.prices) {
        return;
    }

    let previousValue = select.val();

    select.html('');
    $.each(caps.options, function (value, text) {
        let price = caps.prices[value] || {};
        select.append($('<option>', {
            value: value,
            text: text,
            'data-price': price['data-price'] || 0,
            'data-margin': price['data-margin'] || 0,
        }));
    });

    let stillAvailable = select.find('option').filter(function () {
        return this.value === previousValue;
    }).length;

    if (previousValue && stillAvailable) {
        select.val(previousValue);
    }

    select.trigger('change');
}

/**
 * Update wheel line item from an API response
 * @param wheelField (wheel, wheel_inner, wheel_outer, wheel_front, wheel_rear)
 * @param index (the index on the list of items)
 */
function updateWheelInfo(wheelField, index) {

    let item_row = $(`.item-row[data-item-type="${wheelField}"]`).eq(index),
        item_partnumber = item_row.find('input.partnumber').val(),
        item_quantity = item_row.find('input.quantity').val();

    if (item_partnumber && item_quantity) {
        helloSpinnyBoi();

        // get wheel data
        $.ajax({
            type: "post",
            url: api_endpoints['wheel_info'],
            data: {
                wheelPart: item_partnumber,
                quantity: item_quantity,
                vendor: document.querySelector('#vendor').value
            }
        }).done(function (result) {
            item_row.find('input.partnumber').removeClass('invalid');
            item_row.find('input.partnumber').addClass('valid');
            item_row.find('input.price').val(result.price);
            item_row.find('span.price').html(formatPrice(result.price));
            item_row.find('input.original-price').val(result.original_price);
            item_row.find('span.original-price').html(formatPrice(result.original_price));
            item_row.find('span.title').html(result.title);
            item_row.find('input.title').val(result.title);
            item_row.find('span.map').html(formatPrice(result.map));
            item_row.find('span.inventory').html(result.inventory);
            item_row.find('span.margin').html(formatPrice(result.margin));
            item_row.find('.image-upload-wrapper img').attr('src', result.image);
            item_row.find('input.image-url').val(result.image);
            item_row.find('input.discount').val(result.wholesale_discount ? Math.floor(result.wholesale_discount) : 0);

            if ($('.item-row[data-item-type="tire"]').length > 0) {
                $('.item-row[data-item-type="tire"]').each(element => {
                    updateTireInfo('tire', element);
                });
            }

            showUpsell(result.brand, result.price, result.forged);

            if (result.warning) {
                notify(result.warning, "warning");
            }

        }).fail(function (error) {
            let message = 'Wheel Part Number not found.';
            if (error.responseJSON && error.responseJSON.message) {
                message = error.responseJSON.message;
            }
            item_partnumber = [];
            item_quantity = [];
            item_row.find('input.partnumber').removeClass('valid');
            item_row.find('input.partnumber').addClass('invalid');
            item_row.find('input.price').val(0);
            item_row.find('span.price').html(formatPrice(0));
            item_row.find('input.original-price').val(0);
            item_row.find('span.original-price').html(formatPrice(0));
            item_row.find('span.title').html('');
            item_row.find('input.title').val('');
            item_row.find('span.map').html(formatPrice(0));
            item_row.find('span.inventory').html(0);
            item_row.find('span.margin').html(formatPrice(0));
            item_row.find('.image-upload-wrapper img').attr('src', '');
            item_row.find('input.image-url').val('');
            item_row.find('input.discount').val(0);
            
            hideUpsell();
            notify(message, 'error');
        }).always(function () {
            updateUpsellDropdowns(item_partnumber, item_quantity);
            updateTotals();
            byeSpinnyBoi();
        });
    } else {
        resetItemInfo(item_row);
        updateTotals();
        hideUpsell();
    }
}

/**
 * Update tire line item from an API response
 * @param tireField (tire, tire_inner, tire_outer, tire_front, tire_rear)
 * @param index (the index on the list of items)
 */
function updateTireInfo(tireField, index) {

    let item_row = $(`.item-row[data-item-type="${tireField}"]`).eq(index),
        item_partnumber = item_row.find('input.partnumber').val(),
        item_quantity = item_row.find('input.quantity').val(),
        wheel_partnumber = $('.item-row[data-item-type="wheel"]').eq(index).find('input.partnumber').val();

    const wheel_quantity = (wheel_partnumber) ? item_quantity : '';

    if (item_partnumber && item_quantity) {
        helloSpinnyBoi();
        $.ajax({
            type: "post",
            url: api_endpoints['tire_info'],
            data: {
                tirePart: item_partnumber,
                wheelPart: wheel_partnumber,
                quantity: item_quantity,
                vendor: $('#vendor').val()
            }
        }).done(function (result) {
            item_row.find('input.partnumber').removeClass('invalid');
            item_row.find('input.partnumber').addClass('valid');
            item_row.find('input.price').val(result.price);
            item_row.find('span.price').html(formatPrice(result.price));
            item_row.find('input.original-price').val(result.original_price);
            item_row.find('span.original-price').html(formatPrice(result.original_price));
            item_row.find('span.title').html(result.title);
            item_row.find('input.title').val(result.title);
            item_row.find('input.size').val(result.size);
            item_row.find('span.map').html(formatPrice(result.map));
            item_row.find('span.inventory').html(result.quantity);
            item_row.find('span.discounted').html(formatPrice(result.discount));
            item_row.find('span.margin').html(formatPrice(result.margin));
            item_row.find('.image-upload-wrapper img').attr('src', result.image);
            item_row.find('input.image-url').val(result.image);
            item_row.attr('data-oversize-fee', result.oversize_fee ?? 0);
            updateUpsellDropdowns(wheel_partnumber, wheel_quantity, item_partnumber);

            if (result.warning) {
                notify(result.warning, "warning");
            }

        }).fail(function (error) {
            let message = 'Tire Inventory Number not found.';
            if (error.hasOwnProperty('messages')) {
                message = error.messages;
            }
            item_row.find('input.partnumber').removeClass('valid');
            item_row.find('input.partnumber').addClass('invalid');
            item_row.find('input.price').val(0);
            item_row.find('span.price').html(formatPrice(0));
            item_row.find('input.original-price').val(0);
            item_row.find('span.original-price').html(formatPrice(0));
            item_row.find('span.title').html('');
            item_row.find('input.title').val('');
            item_row.find('span.map').html(formatPrice(0));
            item_row.find('span.inventory').html(0);
            item_row.find('span.discounted').html(0);
            item_row.find('span.margin').html(formatPrice(0));
            item_row.find('.image-upload-wrapper img').attr('src', '');
            item_row.find('input.image-url').val('');
            item_row.find('input.discount').val();
            item_row.attr('data-oversize-fee', 0);

            notify(message, 'error');
        }).always(function () {
            updateTotals();
            byeSpinnyBoi();
        });
    } else {
        resetItemInfo(item_row);
        updateTotals();
    }
}

/**
 * Update suspension data form API response
 * @param suspension_line_item suspension line item element
 */
function updateSuspensionInfo(suspension_line_item) {

    let item_row = suspension_line_item.parents('tr'),
        item_partnumber = item_row.find('input.partnumber').val(),
        item_quantity = item_row.find('input.quantity').val();

    if (item_partnumber && item_quantity) {
        helloSpinnyBoi();

        $.ajax({
            type: "post",
            url: api_endpoints['suspension_info'],
            data: {
                suspensionPart: item_partnumber,
                quantity: item_quantity,
                vendor: $('#vendor').val()
            }
        }).done(function (result) {
            if (result.alert) {
                item_row.find('input.partnumber').removeClass('invalid');
                item_row.find('input.partnumber').addClass('valid');
                item_row.find('input.price').val(0);
                item_row.find('span.price').html(formatPrice(0));
                item_row.find('input.original-price').val(0);
                item_row.find('span.original-price').html(formatPrice(0));
                item_row.find('span.title').html('');
                item_row.find('input.title').val('');
                item_row.find('span.inventory').html(0);
                item_row.find('span.discounted').html(0);
                item_row.find('span.margin').html(formatPrice(0));
                item_row.find('.image-upload-wrapper img').attr('src', '');
                item_row.find('input.image-url').val('');
                item_row.find('input.item-id').val('');
                item_row.find('input.item-cat').val('');

                suspension_line_item.parents('.item-row').find('.suspension-wrapper').html('');

                notify(result.alert, 'error');
            } else {
                item_row.find('input.partnumber').removeClass('invalid');
                item_row.find('input.partnumber').addClass('valid');
                item_row.find('input.price').val(result.price);
                item_row.find('span.price').html(formatPrice(result.price));
                item_row.find('input.original-price').val(result.price);
                item_row.find('span.original-price').html(formatPrice(result.price));
                item_row.find('span.title').html(result.title);
                item_row.find('input.title').val(result.title);
                item_row.find('span.inventory').html(result.quantity);
                item_row.find('span.discounted').html(formatPrice(result.discount));
                item_row.find('span.margin').html(formatPrice(result.margin));
                item_row.find('.image-upload-wrapper img').attr('src', result.image);
                item_row.find('input.image-url').val(result.image);
                item_row.find('input.item-id').val(result.id);
                item_row.find('input.item-cat').val(result.cat);
                item_row.find('input.discount').val(result.wholesale_discount ? Math.floor(result.wholesale_discount) : 0);

                updateDiscountedPrice(item_row.find('input.discount'), result.wholesaler);
                suspension_line_item.parents('.item-row').find('.suspension-wrapper').html(result.dropdowns);

                if (result.warning) {
                    notify(result.warning, 'warning');
                }
            }

        }).fail(function (error) {
            let message = `Suspension/Sell2 SKU not found. \n SKU needs to match EXACT to sell2/SLAP SKU`;
            if (error.hasOwnProperty('messages')) {
                message = error.messages;
            }
            item_row.find('input.partnumber').removeClass('invalid');
            item_row.find('input.partnumber').addClass('valid');
            item_row.find('input.price').val(0);
            item_row.find('span.price').html(formatPrice(0));
            item_row.find('input.original-price').val(0);
            item_row.find('span.original-price').html(formatPrice(0));
            item_row.find('span.title').html('');
            item_row.find('input.title').val('');
            item_row.find('span.inventory').html(0);
            item_row.find('span.discounted').html(0);
            item_row.find('span.margin').html(formatPrice(0));
            item_row.find('.image-upload-wrapper img').attr('src', '');
            item_row.find('input.image-url').val('');
            item_row.find('input.item-id').val('');
            item_row.find('input.item-cat').val('');

            suspension_line_item.parents('.item-row').find('.suspension-wrapper').html('');

            notify(message, 'error');
        }).always(function () {
            byeSpinnyBoi();
            updateTotals();
        });
    } else {
        resetItemInfo(item_row);
        updateTotals();
    }
}

/**
 * Look up an 'other' line item's partnumber against sell2 (suspension_info). If a
 * match is found, stash its id/cat in the hidden fields and auto-populate the title
 * and price inputs from the sell2 record.
 * @param other_line_item 'other' line item element
 */
function updateOtherItemId(other_line_item) {
    let item_row = other_line_item.parents('tr'),
        item_partnumber = item_row.find('input.partnumber').val(),
        item_quantity = item_row.find('input.quantity').val();

    if (!item_partnumber || !item_quantity) {
        item_row.find('input.item-id').val('');
        item_row.find('input.item-cat').val('');
        return;
    }

    helloSpinnyBoi();

    $.ajax({
        type: "post",
        url: api_endpoints['suspension_info'],
        data: {
            suspensionPart: item_partnumber,
            quantity: item_quantity,
            vendor: $('#vendor').val()
        }
    }).done(function (result) {
        item_row.find('input.item-id').val(result.id);
        item_row.find('input.item-cat').val(result.cat);
        item_row.find('input.title').val(result.title);
        item_row.find('input.price').val(result.price);
    }).fail(function (error) {
        let message = `Sell2 SKU not found. \n SKU needs to match EXACT to sell2/SLAP SKU \nIgnore if Vendor Quote`;
        if (error.hasOwnProperty('messages')) {
            message = error.messages;
        }

        item_row.find('input.item-id').val('');
        item_row.find('input.item-cat').val('');

        notify(message, 'error');
    }).always(function () {
        byeSpinnyBoi();
        updateTotals();
    });
}

/**
 * Update totals and other data when a dropdown option has been changed
 * @param dropdown the dropdown element
 */
function updateSuspensionOptionData(dropdown) {
    let option = dropdown.find('option:selected');
    let dropdown_option_wrapper = dropdown.parents('.suspension-option-wrapper');

    dropdown_option_wrapper.find('.option-title').val(option.data('title'));
    dropdown_option_wrapper.find('.option-dnum').val(option.data('dnum'));
    dropdown_option_wrapper.find('.option-onum').val(option.data('onum'));
    dropdown_option_wrapper.find('.option-price').val(option.data('price'));

    updateDiscountedPrice(dropdown.parents('.item-row').find('input.discount'));
    updateTotals();
}

/**
 * Update totals section
 * TODO: might need to do some cleanup as it will get hard to understand
 */
function updateTotals() {
    let price_fields = document.querySelectorAll("input.price"),
        original_price_wts = document.querySelectorAll("input.price[data-type]"),
        original_price_non_wts = Array.from(document.querySelectorAll("input.original-price")).filter((element) => element.getAttribute('data-type') == null),
        discount_field = document.querySelector('input.discount-price'),
        discount_reason = document.querySelector('select.discount-reason'),
        margin_fields = document.querySelectorAll('span.margin'),
        totals_element = document.querySelector('.table-totals'),
        sub_total = 0,
        total_original_price = 0,
        flat_discount = 0,
        oversize_fee = 0,
        percentage_discount,
        margin = 0,
        other_total = 0,
        suspension_dropdown_total_price = 0,
        total_price;

    // find item subtotal (includes % discounts)
    price_fields.forEach(function (element, index) {
        let val = element.value;
        if (val) {
            sub_total += +val;
        }
    });

    // find original pricing (to find out % discount)
    [...original_price_non_wts, ...original_price_wts].forEach(function (element, index) {
        let val = $(element).val();
        if (val) {
            total_original_price += +val;
        }
    });

    // add "other" item prices to total_original_price; tracked separately so
    // they can be excluded from the profit calculation.
    document.querySelectorAll('tr[data-item-type="other"] input.price').forEach(function (element) {
        let val = $(element).val();
        if (val) {
            total_original_price += +val;
            other_total += +val;
        }
    });

    // adds total for oversize tire fee
    const currentVendor = document.querySelector('#vendor')?.value ?? '';
    const hideOversizeFee = currentVendor === 'Only Tires' || currentVendor === 'SD Wheel Wholesale';

    if (!hideOversizeFee) {
        document.querySelectorAll('tr[data-item-type="tire"]').forEach(function (element) {
            let fee = parseFloat(element.getAttribute('data-oversize-fee')) || 0;
            oversize_fee += fee;
        });
    }

    // find total margin
    margin_fields.forEach(function (element, index) {
        let val = accounting.unformat($(element).html());
        if (val) {
            margin += +val;
        }
    });

    // find percentage discount
    percentage_discount = total_original_price - sub_total + suspension_dropdown_total_price;

    if ((discount_field && discount_field.value) && (discount_reason && discount_reason.value)) {
        flat_discount += discount_field.value;
    }

    // total price
    total_price = total_original_price - percentage_discount - flat_discount;

    totals_element.querySelector('.subtotal').innerHTML = (formatPrice(total_original_price)); // use original price as subtotal on interface
    totals_element.querySelector('.percent-discount').innerHTML = (formatPrice(percentage_discount));
    totals_element.querySelector('.flat-discount').innerHTML = (formatPrice(flat_discount));
    const oversizeFeeEl = totals_element.querySelector('.oversize-fee');
    if (oversizeFeeEl) {
        total_price += oversize_fee;
        oversizeFeeEl.innerHTML = (formatPrice(oversize_fee));
        oversizeFeeEl.closest('tr')?.classList.toggle('d-none', hideOversizeFee);
    }
    totals_element.querySelector('.total-margin').innerHTML = (formatPrice(margin));
    totals_element.querySelector('.total').innerHTML = (formatPrice(total_price));
    totals_element.querySelector('input#total_price').value = (total_price);
    const profit_base = total_price - other_total;
    const profit_percent = profit_base > 0 ? (margin / profit_base) * 100 : 0;
    const profit_element = totals_element.querySelector('.profit-percent');
    if (profit_element) {
        profit_element.innerHTML = parseFloat(profit_percent).toFixed(2);
    }
}

/**
 * Add new line item.
 * @param that existing line item element
 */
function addLineItem(that) {

    // get html of the clicked row
    const new_line_item = that.parents('tr').clone(),
        last_similar_row = that.parents('tbody').find(`tr[data-item-type="${that.parents('tr').data('item-type')}"]`).last(),
        current_loop = $(new_line_item).data('item-loop'),
        last_loop = last_similar_row.data('item-loop'),
        new_loop = last_loop + 1;

    $(new_line_item).attr('data-item-loop', new_loop);

    // clean up inputs (ignore quantity)
    $(new_line_item).find('input.partnumber,input.title,input.price').val('');

    // update input names with the loop number. We need each new line item to have the last
    // loop in order for values to be structured correctly during saving
    $(new_line_item).find('input').each(function (index, element) {
        let input_name = $(element).attr('name');
        $(element).attr('name', input_name.replace(`[${current_loop}]`, `[${new_loop}]`));
    });
    $(new_line_item).data('item-loop', new_loop);

    // clean up labels
    resetItemInfo(new_line_item);
    $(new_line_item).find('input.discount').val(0);

    // add row below the last one
    last_similar_row.after(new_line_item);

    enableDeleteConfirmationPlugin();
    updateTotals();
}

/**
 * Remove new line item.
 * @param that line item element to be removed
 */
function removeLineItem(that) {
    that.parents('tr').remove();
    updateTotals();
}

/**
 * Update a line item whenever a change has been made to it
 * @param that line item that triggered the change
 */
function updateLineItem(that) {
    let line_item = that.parents('.item-row');
    let item_type = line_item.data('item-type');

    // we need to find index of the given item type in order to match it against the same wheel or tire index
    let index = line_item.index(`.item-row[data-item-type="${item_type}"]`);
    if (item_type === 'wheel') {
        updateWheelInfo('wheel', index);
    } else if (item_type === 'tire') {
        updateTireInfo('tire', index);
    } else if (item_type === 'suspension') {
        updateSuspensionInfo(that);
    } else if (item_type === 'other') {
        updateOtherItemId(that);
        updateTotals();
    } else if (line_item.hasClass('upsell')) {
        updateUpsellPrice(that);
        updateTotals();
    } else {
        updateTotals();
    }
}

/**
 * Updates fitment warning fields if wheel/tire/ymm are incompatible
 *
 * @param that line item that triggered the change
 */
function updateFitmentWarning(that) {
    let alert_text_top = $('#alert-text-top'),
        alert_text_bottom = $('#alert-text-bottom'),
        wheel, tire = '';

    if (that.attr('id') === 'drive') {
        wheel = $('.item-row[data-item-type="wheel"] input.partnumber').val();
        tire = $('.item-row[data-item-type="tire"] input.partnumber').val();
    } else {
        let line_item = that.parents('.item-row'),
            item_type = line_item.data('item-type');

        if (item_type === 'wheel') {
            wheel = that.val();
            tire = $('.item-row[data-item-type="tire"] input.partnumber').val();
        } else if (item_type === 'tire') {
            wheel = $('.item-row[data-item-type="wheel"] input.partnumber').val();
            tire = that.val();
        }
    }

    let formdata = new FormData();
    formdata.append("year", $('#year').val());
    formdata.append("make", $('#make').val());
    formdata.append("model", $('#model').val());
    formdata.append("drive", $('#drive').val());
    formdata.append("trim", $('#trim').val());
    formdata.append("wheelPart", wheel);
    formdata.append("tirePart", tire);
    formdata.append("vendor", document.querySelector("#vendor").value);

    let requestOptions = {
        method: 'POST',
        body: formdata,
        redirect: 'follow'
    };

    fetch(api_endpoints['check_fitment'], requestOptions)
        .then(response => response.text())
        .then(result => {
            result = JSON.parse(result);

            if (result.hasOwnProperty('warning') && result.warning) {
                alert_text_top.text('Warning! ' + result.warning);
                alert_text_bottom.text('Warning! ' + result.warning);
                alert_text_top.parent('div').show();
                alert_text_bottom.parent('div').show();

                notify(result.warning, 'warning')
            } else {
                alert_text_top.parent('div').hide();
                alert_text_bottom.parent('div').hide();
                alert_text_top.text('');
                alert_text_bottom.text('');
            }
        });
}

/**
 * Calculate upsell pricing
 * @param that upsell line item element
 */
function updateUpsellPrice(that) {
    let item_row = that.parents('.item-row'),
        price = item_row.find('select.partnumber :selected').data('price'),
        margin = item_row.find('select.partnumber :selected').data('margin') || 0,
        quantity = item_row.find('.quantity').val(),
        toolPrice = item_row.find('select.partnumber :selected').data('tool') || 0;

    let item_price = +price * +quantity + +toolPrice;

    if (!Number.isFinite(item_price)) {
        item_price = 0;
    }

    item_row.find('.column--small input.price').val(item_price);
    item_row.find('input.original-price').val(item_price);
    item_row.find('span.original-price').html(formatPrice(item_price));
    item_row.find('span.margin').html(formatPrice(margin));
    item_row.find('input.price').trigger('change');
}

function updatePaymentPrice(that) {
    let price = that.val(),
        item_row = that.parents('.item-row')

    item_row.find('input.original-price').val(price);
    item_row.find('span.original-price').html(formatPrice(price));
}

/**
 * Updates the customer price based on the % discount
 * @param that wheel/tire/suspension line item
 */
function updateDiscountedPrice(that) {
    let discount_percentage = +that.val(),
        item_row = that.parents('.item-row'),
        original_price = +item_row.find('input.original-price').val(),
        new_price = 0

    if (original_price > 0) {
        new_price = accounting.unformat(original_price - (original_price * (discount_percentage / 100)));
    }

    // calculate dropdown option price for upsells.
    // The percentage discount is only added on the suspension itself.
    if (item_row.data('item-type') === 'suspension') {
        item_row.find('.option-price').each(function (index, element) {
            let val = $(element).val();
            if (val) {
                new_price += +val;
            }
        });
    }


    item_row.find('input.price').val(new_price);
    item_row.find('span.price').html(formatPrice(new_price));
}

/**
 * Reset a line item to default values
 * @param item_row line item element to be reset
 */
function resetItemInfo(item_row) {
    item_row.find('input.price').val(0);
    item_row.find('span.price').html('$0');
    item_row.find('input.original-price').val(0);
    item_row.find('span.original-price').html('$0');
    item_row.find('input.title').val('');
    item_row.find('span.title').html('');
    item_row.find('span.map').html('$0');
    item_row.find('span.inventory').html('0');
    item_row.find('span.discounted').html('$0');
    item_row.find('span.margin').html('$0');
    item_row.find('.suspension-wrapper').html('');
    item_row.find('.image-upload-wrapper img').attr('src', '');
    item_row.find('input.image-url').val('');
}

/**
 * Enable a deletion confirmation for existing and new added line items
 */
function enableDeleteConfirmationPlugin() {
    $('.btn--remove-row').confirmation({
        animation: false,
        popout: true,
        placement: 'left',
        btnOkClass: 'btn-danger btn-xs',
        btnCancelClass: 'btn-success btn-xs',
        onConfirm: function (e) {
            e.preventDefault();
            removeLineItem($(e.target));
        }
    });
}

/**
 * Show upsell dropdowns except for spare which needs both wheel and tire to be selected
 *
 * @param brand wheel brand to hide/show nqarp upsell
 * @param price wheel price to calculate nqarp price
 */
function showUpsell(brand, price, forged) {
    $('.item-row.upsell').each(function (index, element) {
        let type = $(element).data('item-type');

        if (type === 'spare') {
            return;
        }

        if (type === 'polish' && !forged) {
            $(element).hide();
            return;
        }

        $(element).show();
    })
}

/**
 * Hide upsell dropdowns.
 */
function hideUpsell() {
    let partnumbers = [];
    $('tr[data-item-type="wheel"]').each(function (index, element) {
        if ($(element).find('.partnumber').val()) {
            partnumbers.push($(element).find('.partnumber').val());
        }
    });
    if (partnumbers.length < 1) {
        $('.item-row.upsell').each(function (index, element) {
            $(element).hide()
        })
    }
}

/**
 * Copy cart link to clipboard
 */
function copyCartLink(copy_btn, cart_link) {
    let sampleTextarea = document.createElement("textarea");
    document.body.appendChild(sampleTextarea);
    sampleTextarea.value = cart_link.attr('href');
    sampleTextarea.select();
    document.execCommand('copy');
    document.body.removeChild(sampleTextarea);


    // flash effect on copy btn
    copy_btn.addClass('flash');
    copy_btn.html('copied');

    setTimeout(function () {
        copy_btn.removeClass('flash');
    }, 2000);
}


/**
 * Opens a larger image in a modal whenever the thumbnail is clcked
 *
 * @param {HTMLFormElement} modal
 * @param {HTMLFormElement} img
 */
function loadImageOnModal(modal, img) {
    if (img.attr('src')) {
        modal.find('img').attr('src', img.attr('src'));
        modal.modal('show');
    }
}

/**
 * Handle Image upload via AJAX and add the URL to the hidden input
 *
 * @param that
 */
function uploadImage(that) {

    if (that.prop('files')[0]) {
        helloSpinnyBoi();

        let data = new FormData(),
            line_item = that.parents('.item-row');

        data.append('image', that.prop('files')[0]);
        data.append('partnumber', line_item.find('input.partnumber').val() ?? null);

        $.ajax({
            type: 'POST',
            url: api_endpoints.upload_image,
            data: data,
            cache: false,
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
        }).done(function (result) {

            if (result.hasOwnProperty('url') && result.url) {
                line_item.find('.image-url').val(result.url);
                line_item.find('.image-upload-wrapper img').attr('src', result.url);
                line_item.find('.custom-image-upload').val('');
            }

            let message = 'Image uploaded successfully.';
            if (result.hasOwnProperty('messages')) {
                message = result.messages;
            }

            notify(message, 'success');
        }).fail(function (error) {

            let message = 'An error has occurred.';
            if (error.hasOwnProperty('messages')) {
                message = error.messages;
            }

            notify(message, 'error');
        }).always(function () {
            byeSpinnyBoi();
        });
    }
}

/**
 * Toggle upsells to hide/show
 */
/**
 * Clear the lugs dropdown back to its placeholder when the YMM is incomplete,
 * so the previous vehicle's options are not left on screen. Visibility is left
 * to toggleUpsell(), which force-shows the row on each upsell refresh.
 */
function resetLugOptions() {
    let select = $('tr[data-item-type="lugs"] select.partnumber');

    select.html($('<option>', { value: '0', text: 'No Lugs Needed', 'data-price': 0 }));
    select.trigger('change');
}

function toggleUpsell() {
    let fps_exclude_upsell = '.item-row.upsell[data-item-type="sensor"], .item-row.upsell[data-item-type="lugs"], .item-row.upsell[data-item-type="shine"], .item-row.upsell[data-item-type="balance"]';
    let vendor_upsell = '.item-row.upsell[data-item-type="sensor"], .item-row.upsell[data-item-type="lugs"]';

    if (isVendor()) {
        $(vendor_upsell).show();
    } else if (isFps() || isOT()) {
        $(fps_exclude_upsell).hide();
    } else {
        $(fps_exclude_upsell).show();
    }
}

/**
 * Toggle discount percent fields for wholesale
 *
 * @param vendor
 */
function toggleDiscountFields(vendor) {
    $.ajax({
        type: "post",
        url: api_endpoints['check_wholesale'],
        data: {
            vendor: vendor,
        }
    }).done(function (result) {
        if (result.hasOwnProperty('is_wholesale')) {
            if (result.is_wholesale) {
                $(".discount").attr("readonly", false);
            } else {
                $(".discount").attr("readonly", true);
                $(".discount").val(0);
            }
        }
    }).fail(function (error) {
        let message = 'Error checking wholesale';
        if (error.hasOwnProperty('messages')) {
            message = error.messages;
        }

        notify(message, 'error');
    });
}

/**
 * Checks if the Company/Vendor box is set to 'SD Wheel Wholesale'
 * @returns bool true if SD Wheel Wholesale
 */
function isSDW() {
    return String($('#vendor').val()).trim().toLowerCase() === 'sd wheel wholesale';
}

/**
 * Set charge tax dropdown value
 * @param {*} val (1 - Yes / 0 - No)
 */
function setChargeTax(val) {
    const charge_tax = $('#charge_tax');

    if (charge_tax.data('manualOverride')) return;

    if (String(charge_tax.val()) !== String(val)) {
        charge_tax.val(val).trigger('change');
    }
}

$(function () {
    $('#charge_tax').on('change', function (e) {
        if (e.originalEvent) $(this).data('manualOverride', true);
    });
});

// bind notify to window so that it can be used within notify.blade.php
window.notify = notify;